import React, { useCallback } from 'react';
import { compose } from 'ramda';
import qs from 'qs';
import { Redirect, useHistory } from 'react-router-dom';

import LatestOffers from 'containers/LatestOffers';
import { ContentShowCards } from 'containers/ContentMarketing/ContentShowCards';
import SearchBar from 'containers/SearchBar';
import { useFetchData } from 'effects';
import { useSelector } from 'react-redux';
import { isFinanceUser } from 'store/modules/auth';
import { selectedCompanySelector, selectedTaSelector } from 'store/modules/agents/selectors';

import connect from './Landing.state';
import { noop } from 'utils';
import { useDynamicParameters } from 'context/DynamicParameters/DynamicParametersContext';
import { Loader } from 'components/Loader/Loader';
import classNames from 'classnames';

export const Landing = ({ fetchLatestOffers = noop, offersStatus, offers = [] }) => {
  const { dynamicParameters } = useDynamicParameters();
  const loaded = useFetchData(offersStatus, fetchLatestOffers, [{ limit: 3 }]);

  const isFinance = useSelector(isFinanceUser);
  const selectedCompany = useSelector(selectedCompanySelector);
  const selectedTa = useSelector(selectedTaSelector);

  const history = useHistory();
  const handleSearchButtonClick = useCallback(
    searchQuery => {
      const queryWithCompanyTa = {
        ...searchQuery,
        ...(selectedCompany?.uuid && { companyUuid: selectedCompany.uuid }),
        ...(selectedTa?.uuid && { tauuid: selectedTa.uuid }),
      };
      history.push(`/search/beta/?${qs.stringify(queryWithCompanyTa)}`);
    },
    [history, selectedCompany, selectedTa]
  );

  // Finance redirect
  // OWA-3246
  // if a finance user tries to get to the landing page, send them to the bookings page
  if (isFinance && window) {
    return <Redirect to="/bookings" />;
  }

  return (
    <Loader isLoading={!loaded}>
      <div className="w-full relative">
        <div
          style={{
            backgroundImage: dynamicParameters.TA_LANDING_BACKGROUND_IMAGE
              ? `url('${dynamicParameters.TA_LANDING_BACKGROUND_IMAGE}')`
              : null,
          }}
          className={'h-[592px] pt-[117px] pb-[127px] px-[20px] bg-cover bg-center bg-blend-darken bg-black-true/20'}
        >
          <h1 className="block p-0 m-auto uppercase text-[64px] font-normal mb-[80px] font-noe-display text-center text-white">
            {dynamicParameters.TA_LANDING_WELCOME_TEXT}
          </h1>
          <div className="container mx-auto max-w-1280px">
            <div
              className="search-bar-container p-5 max-w-1190px"
              style={{ backgroundColor: 'rgba(248,248,248,0.85)' }}
            >
              <SearchBar onSearch={handleSearchButtonClick} memberships={[]} />
            </div>
          </div>
        </div>
        <div className="absolute top-0 left-0 h-[592px] text-white text-sm font-hurmegeometric-sans w-full pointer-events-none">
          <div className="caption-wrapper absolute right-[40px] bottom-[40px] text-right">
            {dynamicParameters.TA_LANDING_DESCRIPTION_HEADER && (
              <span className="block mb-20px uppercase">{dynamicParameters.TA_LANDING_DESCRIPTION_HEADER}</span>
            )}
            {dynamicParameters.TA_LANDING_DESCRIPTION_BOLD_HEADER && (
              <span className="block font-bold uppcase">{dynamicParameters.TA_LANDING_DESCRIPTION_BOLD_HEADER}</span>
            )}
            {dynamicParameters.TA_LANDING_DESCRIPTION_BODY && (
              <span className="block">
                {dynamicParameters.TA_LANDING_DESCRIPTION_BODY.replace(/\r/g, '')
                  .split(/\n/)
                  .map((item, key) => (
                    <>
                      {key === 0 ? null : <br />}
                      {item}
                    </>
                  ))}
              </span>
            )}
          </div>
        </div>
        {/* Replace Latest Offers with new marketing section */}
        {dynamicParameters.ENABLE_MARKETING_WORKSPACE_TEMP && <ContentShowCards />}
      </div>
    </Loader>
  );
};

export default compose(connect)(Landing);
